<section class="admin-section" data-test="staff-sync-panel">
  <div class="admin-section__head">
    <h2 class="admin-h2">Staff sync</h2>
    <button type="button" class="btn" (click)="load()" [disabled]="loading" data-test="staff-sync-refresh">Refresh</button>
  </div>
  <p class="admin-lede">
    Staff are created in Orbit and brought across to Tuition Management on a schedule. The sync never sends an email and never deletes an account.
  </p>

  @if (loading) {
    <p>Loading…</p>
  }

  @if (error) {
    <div class="tw:my-2 tw:p-3 tw:border tw:border-red-500 tw:bg-red-50 tw:text-red-900 tw:rounded" data-test="staff-sync-error">{{error}}</div>
  }

  @if (!loading && !error && report) {
    @if (!report.switchEnabled) {
      <div class="tw:my-2 tw:p-3 tw:border tw:border-amber-500 tw:bg-amber-50 tw:text-amber-900 tw:rounded" data-test="staff-sync-off">
        The staff sync is off. Turn on "orbit.staff-sync" above to start it; check the role mapping below first.
      </div>
    }

    @if (!report.lastRun) {
      <p class="tw:opacity-60" data-test="staff-sync-never">The staff sync has not run yet.</p>
    } @else {
      <div class="tw:my-2" data-test="staff-sync-last-run">
        Last run: <strong>{{report.lastRun.startedUtc | date:'dd/MM/yyyy HH:mm'}}</strong>
        <span [class.tw:text-red-700]="report.lastRun.outcome !== 'Success'" data-test="staff-sync-outcome"> · {{report.lastRun.outcome}}</span>
        @if (report.lastRun.error) {
          <span class="tw:text-red-700" data-test="staff-sync-run-error"> ({{report.lastRun.error}})</span>
        }
      </div>

      <div class="tw:grid tw:grid-cols-2 tw:md:grid-cols-4 tw:gap-2 tw:my-3">
        @for (count of counts(); track count.test) {
          <div class="tw:p-2 tw:border tw:border-gray-200 tw:rounded" [attr.data-test]="'count-' + count.test">
            <div class="tw:text-xl tw:font-bold">{{count.value}}</div>
            <div class="tw:text-sm tw:opacity-75">{{count.label}}</div>
          </div>
        }
      </div>

      <h3 class="admin-h3">TM-only staff</h3>
      <p class="admin-lede">Staff accounts in Tuition Management with no Orbit match. The sync leaves them alone.</p>
      @if (report.lastRun.leapOnlyStaff?.length) {
        <div class="tw:overflow-x-auto">
        <table class="admin-table" data-test="leap-only-table">
          <thead>
            <tr><th class="tw:text-left">Name</th><th class="tw:text-left">Email</th><th class="tw:text-left">Roles</th><th class="tw:text-left">Active</th></tr>
          </thead>
          <tbody>
            @for (user of report.lastRun.leapOnlyStaff; track user.userId) {
              <tr data-test="leap-only-row">
                <td data-label="Name">{{fullName(user.firstName, user.lastName)}}</td>
                <td data-label="Email"><admin-email [value]="user.email" /></td>
                <td data-label="Roles">{{user.roleCodes?.join(', ')}}</td>
                <td data-label="Active">{{user.active ? 'Yes' : 'No'}}</td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      } @else {
        <p class="tw:opacity-60" data-test="leap-only-empty">None.</p>
      }

      <h3 class="admin-h3">Conflicts</h3>
      <p class="admin-lede">Orbit users skipped because more than one TM user matched. Resolve the duplicate in Tuition Management.</p>
      @if (report.lastRun.conflictDetails?.length) {
        <div class="tw:overflow-x-auto">
        <table class="admin-table" data-test="conflict-table">
          <thead>
            <tr><th class="tw:text-left">Orbit user</th><th class="tw:text-left">Email</th><th class="tw:text-left">TM users</th><th class="tw:text-left">Reason</th></tr>
          </thead>
          <tbody>
            @for (conflict of report.lastRun.conflictDetails; track conflict.orbitUserId) {
              <tr data-test="conflict-row">
                <td data-label="Orbit user">{{conflict.orbitUserId}}</td>
                <td data-label="Email"><admin-email [value]="conflict.email" /></td>
                <td data-label="TM users">{{conflict.leapUserIds?.join(', ')}}</td>
                <td data-label="Reason">{{conflict.reason}}</td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      } @else {
        <p class="tw:opacity-60" data-test="conflict-empty">None.</p>
      }
    }
  }
</section>
